import { atom } from 'recoil'

export const loggedInState = atom({
    key: 'loggedInState',
    // null = هنوز مشخص نیست (در حال بازیابی نشست) → تا آن موقع صفحهٔ ورود نشان داده نشود
    default: null
})

export const userInfoState = atom({
    key: 'userInfoState',
    default: {}
})

export const loadingState = atom({
    key: 'loadingState',
    default: false
})